// extracted by mini-css-extract-plugin
export default {"colWidth":"colWidth__pOLby"};